import Layout from "@/components/feature/Layout";
import RegionPage from "@/components/feature/RegionPage";

const data = {
  heroTitle: "Seyhan temizlik hizmetleri",
  heroDescription: "Seyhan genelinde daire, apartman, ofis ve site temizliği hizmetleri.",
  description: "Seyhan, Adana'nın tarihi ve merkezi ilçelerinden biridir. Day Temizlik Adana, Seyhan'da daire temizliği, apartman ve site temizliği, inşaat sonrası temizlik, koltuk yıkama, halı yıkama, kuru temizleme ve ilaçlama hizmetlerini profesyonel ekibimizle sunuyoruz. Seyhan temizlik firması arayışlarınıza güvenilir çözümler üretiyoruz.",
  services: [
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi", desc: "Evinizi hijyenik, düzenli ve ferah hale getiren profesyonel daire temizliği." },
    { title: "Apartman Temizliği", path: "/hizmetlerimiz/apartman-temizligi", desc: "Merdiven, giriş ve ortak alanlarda periyodik temizlik." },
    { title: "Bina ve Site Temizliği", path: "/hizmetlerimiz/bina-ve-site-temizligi", desc: "Apartman ve site ortak alanlarında düzenli hijyen." },
    { title: "İnşaat Sonrası Temizlik", path: "/hizmetlerimiz/insaat-sonrasi-temizlik", desc: "Tadilat ve inşaat sonrası detaylı temizlik." },
    { title: "Koltuk Yıkama", path: "/hizmetlerimiz/koltuk-yikama", desc: "Derinlemesine temizlik ile ferah koltuklar." },
    { title: "Halı Yıkama", path: "/hizmetlerimiz/hali-yikama", desc: "Halı yapısına uygun profesyonel yıkama." },
    { title: "Kuru Temizleme ve Ütü", path: "/hizmetlerimiz/kuru-temizleme-ve-utu", desc: "Kıyafetleriniz için özenli temizlik." },
    { title: "İlaçlama", path: "/hizmetlerimiz/ilaclama", desc: "Haşere ve böceklere karşı güvenli uygulama." },
    { title: "Ofis Temizliği", path: "/hizmetlerimiz/ofis-ve-is-yeri-temizligi", desc: "Çalışma alanlarınızda düzenli hijyen." },
  ],
  faqs: [
    { question: "Seyhan'da hangi hizmetleri sunuyorsunuz?", answer: "Daire temizliği, apartman ve site temizliği, inşaat sonrası temizlik, koltuk yıkama, halı yıkama, kuru temizleme, ilaçlama ve ofis temizliği hizmetleri sunuyoruz." },
    { question: "Seyhan'da aynı gün hizmet alınabilir mi?", answer: "Acil durumlar ve müsaitlik durumuna göre aynı gün hizmet alınabilir." },
    { question: "Seyhan'da hizmet almak için nasıl randevu oluşturulur?", answer: "Telefon veya WhatsApp üzerinden bize ulaşarak randevu oluşturabilirsiniz." },
  ],
  ctaText: "Seyhan'da temizlik ihtiyacınız için Day Temizlik Adana'dan hızlıca randevu alın.",
  heroImage: "/assets/images/seyhan.jpg",
};

export default function SeyhanPage() {
  return (
    <Layout>
      <RegionPage data={data} />
    </Layout>
  );
}